import { site } from "./site";

export function getThumbUrl(siteSlug) {
  switch (siteSlug) {
    case site.TOCANTINS.slug:
      return {
        url: '/assets/tocantins/banners/BannerSocialShare.png',
        type: 'jpeg',
        height: '500',
        width: '1000'
      }
    case site.DAQUI.slug:
      return {
        url: '/assets/daqui/banners/BannerSocialShare.png',
        type: 'jpeg',
        height: '500',
        width: '1000'
      }
    case site.CBNGO.slug:
      return {
        url: '/assets/cbngo/banners/BannerSocialShare.png',
        type: 'jpeg',
        height: '500',
        width: '1000'
      }
    case site.CBNTO.slug:
      return {
        url: '/assets/cbnto/banners/BannerSocialShare.png',
        type: 'jpeg',
        height: '500',
        width: '1000'
      }
    default:
      return {
        url: '/assets/opopular/banners/BannerSocialShare.png',
        type: 'jpeg',
        height: '500',
        width: '1000'
      }
  }
}
